import React from 'react';
import _ from 'underscore';
import { Table } from 'react-bootstrap';
import { Pie, defaults } from 'react-chartjs-2';
import { Link } from 'react-router-dom'

var colors = {
    blue: '#36a2ec',
    red: '#fa6283',
    yellow: '#fdcd56',
    green: '#56fd72',
    lavender: '#f9a4ff'
}

function PieChart (props) {
    var evs = _(props.events).sortBy('plays').reverse().slice(0,5);

    var chartData = {
        labels: evs.map(function (ev) {
            return ev.title;
        }),
        datasets: [{
            data: _(evs).map('plays'),
            backgroundColor:  Object.keys(colors).map(function (k, i) {
                return colors[Object.keys(colors)[i]]
            }),
            hoverBackgroundColor: Object.keys(colors).map(function (k, i) {
                return colors[Object.keys(colors)[i]]
            })
        }]
    };

    return <div className="clearfix" className='pie-container'>
        <Pie
            data={chartData}
            options={{
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                legend: {
                    display: true,
                    position: 'left',
                    fullWidth: false
                },
                plugins: {
                    datalabels: {
                        display: true,
                        borderColor: 'gray',
                        backgroundColor: 'rgba(236, 236, 236, 0.5)',
                        borderRadius: 5,
                        borderWidth: 1,
                        color: 'black',
                        font: {
                            weight: 'bold'
                        },
                        formatter: function(value) {
                            return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        },

                        anchor: 'center',
                        offset: 30
                    }
                },
            }}
        />
    </div>;
}


PieChart.defaultProps = {
    events: []
};

function List (props) {
    var evs = _(props.events).sortBy('plays').reverse().slice(0,5);

    return <ul className="list-unstyled">
        {evs.map(function (ev, i) {
            return [(<li key={i}>
                <Link className="top-ev" to={"/events/?eventID=" + ev.eventID}
                >
                    {ev.title}
                </Link>
                <span className="top-ev-count"
                >
                    {ev.plays}
                </span>
            </li>),
            (i < evs.length - 1 ? <hr key={'hr-' + i} style={{margin: '0.5em 0'}}/> : null)
            ];
        })}
    </ul>;
}

List.defaultProps = {
    events: []
};

function MostWatched (props) {
    if (!props.events || !props.events.length) {
        return <div className="alert alert-info">
            <p>No data</p>
        </div>;
    }

    // sort by # of plays and show only the top 5
    var evs = _(props.events).sortBy('plays').reverse().slice(0,5);

    return <div>
        <PieChart events={props.events} />
        <List events={props.events} />
    </div>;
}

MostWatched.defaultProps = {
    events: []
};

MostWatched.PieChart = PieChart;
MostWatched.List = List;

export default MostWatched;
